<template>
  <v-app id="searchAirbnbAlterations">
    <v-main>
     <v-container fluid>
       <v-row>
        <v-col cols="12">
          <h1>Airbnb - Reservation alterations</h1>
        </v-col>
       </v-row>
        <v-row dense>
          <v-col cols="1" class="pr-4">
             <v-checkbox v-model="showError" label="Show Errors" class="mt-0"></v-checkbox> 
          </v-col>
          <v-col cols="2">
            <v-btn class="primary" small @click="searchAlterations()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
          </v-col>
        </v-row>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
            
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            fixed-headers
            :search="search"   
            >

            
            <template v-slot:item="props">
              <tr>
              <td>{{ props.item.hoch_id }}</td>
              <td>{{ $moment(props.item.hoch_request_dt).format("DD-MMM-YYYY HH:MM") }}</td>
              <td>{{ $moment(props.item.hoch_stat_dt).format("DD-MMM-YYYY HH:MM") }}</td>
              <td>{{ props.item.hoch_aant_volw }}</td>
              <td>{{ props.item.hoch_aant_kind }}</td>
              <td>{{ props.item.hoch_aant_baby }}</td>
              <td>{{ props.item.hoch_aant_hd }}</td>
              <td>{{ props.item.hoch_van_datum }}</td>
              <td>{{ props.item.hoch_tm_datum }}</td>
              <td>{{ props.item.hoch_origin }}</td>
              <td>{{ props.item.hoch_new_price }}</td>
              <td>{{ props.item.hoch_initiated_by }}</td>
              <td>
                    <v-tooltip bottom v-if="props.item.hoch_stat === 'PENDING'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="orange">mdi-clock-outline</v-icon>
                      </template>
                      <span>Pending</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="props.item.hoch_stat === 'ACCEPTED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="green">mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Accepted</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="props.item.hoch_stat === 'DECLINED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Declined</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="props.item.hoch_stat === 'CANCELLED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Cancelled</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="props.item.hoch_stat === 'VOID'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Voided</span>
                    </v-tooltip>
                </td>
                <td>
                  <v-dialog v-model='modals[props.item.hoch_id]' width='1000'>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                        <v-icon>mdi-text-box-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Description
                      </v-card-title>
                      <v-card-text>
                        <pre style="white-space: pre-wrap; ">{{ props.item.hoch_oms }}</pre>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        
                        <v-btn color="primary" small @click="modals[props.item.hoch_id] = false">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.huov_code}} / {{ props.item.huov_ota_code  }} </a></td>
              <td><v-chip :color=props.item.huov_hust_kleur>{{props.item.huov_hust_code}}</v-chip></td>
              <td>
                  <v-badge v-if="props.item.nott.length!==0" :content="props.item.nott.length">
                  <v-icon @click="nott(props.item.hoch_encrid);">mdi-clipboard-text-outline</v-icon>
                  </v-badge>
                  <v-icon v-if="props.item.nott.length===0" @click="nott(props.item.hoch_encrid);">mdi-clipboard-text-outline</v-icon>
              </td>
              <td>
                  <v-checkbox v-model="props.item.hoch_stat_intern" @change="setKeepInList(props.item.hoch_id, props.item.hoch_stat_intern)"></v-checkbox>
              </td>
              </tr>
              
            </template>
            
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    <nott ref="nott"></nott>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import nott from "@/components/nott";
 export default {
  components: {
    navBar,
    nott,
    
  },
  data() {
    return {
      items: [],
      modals: {},
      search: '',
      showError: false,
      headers: [
        {text: 'Id', value: 'hoch_id'},
        {text: 'Request DT', value: 'hoch_request_dt'},
        {text: 'Status DT', value: 'hoch_stat_dt'},
        {text: 'Adults', value: 'hoch_aant_volw'},
        {text: 'Childs', value: 'hoch_aant_kind'},
        {text: 'Infants', value: 'hoch_aant_baby'},
        {text: 'Pets', value: 'hoch_aant_hd'}, 
        {text: 'Start Date', value: 'hoch_van_datum'},
        {text: 'End Date', value: 'hoch_tm_datum'}, 
        {text: 'Origin', value: 'hoch_origin'}, 
        {text: 'New Price', value: 'hoch_new_price'},
        {text: 'Initiated By', value: 'hoch_initiated_by'},
        {text: 'Status', value: 'klnt_naam'},
        {text: 'Description', value: 'hoch_stat'},
        {text: 'Booking Id / Airbnb', value: 'hoch_oms'},
        {text: 'Booking status', value: 'huov_hust_code'},
        {text: 'Remark'},
        {text: 'Keep in list', value: 'hoch_stat_intern', sortable: false},
      ]
    }  
  },
  mounted() {
      this.searchAlterations();
  },
  methods: {
    nott(hoch_encrid) {
      this.$refs.nott.open("hoch",hoch_encrid,"Airbnb - Reservation alteration remark");
    },
    searchAlterations() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/inpt/airbnb/searchAirbnbAlterations.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchAirbnbAlterations"
          },
          searchAirbnbAlterations: {
            showError: this.showError
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.searchAirbnbAlterations;
          }
        })
        .finally(() => {
          this.loading = false;
        });
        
    },
    setKeepInList(hoch_id, keep_in_list) {
      this.$axios
        .post("ares/json/ares/task/inpt/airbnb/setKeepInListAirbnbAlteration.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "setKeepInListAirbnbAlteration"
          },
          setKeepInListAirbnbAlteration: {
            hoch_id: hoch_id,
            keep_in_list: keep_in_list

          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } 
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};

</script> 
<style scoped>
  .td_markup{
    vertical-align: top;
    border-top: 5px solid transparent; /* trick to add padding to a TD element (which is not possible with CSS normally) */
  }
</style>